import {
  mediaMinSBreakpoint,
  mediaMinXSBreakpoint,
} from '@aboutyou/ui-components';
import {Rect, useDimensions} from 'react-viewport-utils';
import {
  HEADER_DEFAULT_PADDING,
  SEARCH_BAR_TABLET_WIDTH,
  SLIDER_BUTTON_WIDTH,
} from '../../constants';

export const useShouldDisplaySlider = (
  navItemsWrapperRect: Rect | null,
  isSearchBarExpanded: boolean,
) => {
  const {clientWidth} = useDimensions();
  const wrapperPadding = getCategoryNavigationItemPadding(clientWidth);

  if (isSearchBarExpanded) {
    return false;
  }

  return navItemsWrapperRect
    ? navItemsWrapperRect.width +
        wrapperPadding +
        SEARCH_BAR_TABLET_WIDTH +
        SLIDER_BUTTON_WIDTH >=
        clientWidth
    : false;
};

const getCategoryNavigationItemPadding = (clientWidth: number) => {
  // Padding is used left and right, therefore we return the padding multiplied by 2
  if (clientWidth > mediaMinSBreakpoint) {
    return HEADER_DEFAULT_PADDING.largeScreens * 2;
  }

  if (clientWidth > mediaMinXSBreakpoint) {
    return HEADER_DEFAULT_PADDING.desktop * 2;
  }

  return HEADER_DEFAULT_PADDING.tablet * 2;
};
